import React from 'react';
import Box from '@material-ui/core/Box';

const Rule = () => (
  <Box
    borderTop="1px solid"
    color="borders.primary"
    position="absolute"
    width="100vw"
    left={-24}
    top={0}
  />
);

export default Rule;
